<script setup lang="ts">
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'
import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {MessageDeletionType} from '@toolify/server/src/models/mongoose/MessageModel/enum/MessageDeletionType'
import {getDeletedMessageLabelKey} from '@toolify/client/src/modules/chat/functions/getDeletedMessageLabelKey'

interface Props {
  payload: {
    truncatedContent: string
    conversationType?: ConversationType
    messageDeletionType?: MessageDeletionType
  }
}

const props = defineProps<Props>()

const {t} = useI18n()

const deletedMessageLabelKey = computed<string | null>(() => {
  if(!props.payload) {
    return null
  }
  return getDeletedMessageLabelKey({
    conversationType: props.payload.conversationType,
    deletionType: props.payload.messageDeletionType,
  })
})

const displayContent = computed(() => {
  if(deletedMessageLabelKey.value) {
    return t(deletedMessageLabelKey.value)
  }
  if(!props.payload?.truncatedContent) {
    return ''
  }
  return `“${props.payload.truncatedContent}”`
})
</script>

<template>
  <div class="message-notification-item-content">
    <span
      class="message-text"
      :class="{'is-deleted': !!deletedMessageLabelKey}"
      v-if="displayContent"
    >{{displayContent}}</span>
  </div>
</template>

<style scoped lang="scss">
@use '../../../../styles/variables' as variables;

.message-notification-item-content {
  display: flex;
  height: 100%;
  max-width: 100%;
  align-items: center;
}

.message-text {
  font-style: italic;
  font-weight: 300;
  font-size: map-get(variables.$textSizes, text-sm);
  color: map-get(variables.$colors, content-normal);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.is-deleted {
    color: map-get(variables.$colors, content-dim);
  }
}
</style>
